define('cartware/components/Registry',[
	"lodash",
	"lucid"
], function(
	_,
	lucidJS
) {

	var _instance = null;

	var getInstance = function() {
		if (_instance === null) {
			_instance = new Registry();
		}

		return _instance;
	};

	function Registry() {
		if (!(this instanceof Registry)) {
			return getInstance();
		}

		lucidJS.EventEmitter.call(this);

		this._register = {};
	}

	Registry.getInstance = getInstance;

	Registry.prototype = _.create(new lucidJS.EventEmitter, {
		"constructor": Registry,

		_register: null,

		register: function(key, value, graceful) {
			if (key in this._register) {
				if (graceful) return;

				throw "Registry key '" + key + "' has already been set.";
			}

			this._register[key] = value;
			this.flag("available." + key, value);

			return this;
		},

		unregister: function(key) {
			if (key in this._register) {
				delete this._register[key];
			}

			this.unflag("available." + key);

			return this;
		},

		retrieve: function(key, callback) {
			this.bind("available." + key, callback);
		}
	});

	return Registry;
});
